import { render } from "./fb3.vue?vue&type=template&id=19e125eb&scoped=true"
import script from "./fb3.vue?vue&type=script&lang=js"
export * from "./fb3.vue?vue&type=script&lang=js"

import "./fb3.vue?vue&type=style&index=0&id=19e125eb&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19e125eb"]])

export default __exports__